import { defineMessages } from '@jutro/locale';

export default defineMessages({
    RepairShopLocator: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Repair Shop Locator',
        defaultMessage: 'Repair Shop Locator'
    },
    Address: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Address',
        defaultMessage: 'Address'
    },
    TypeYourAddressHere: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Type your address here',
        defaultMessage: 'Type your address here'
    },
    City: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.City',
        defaultMessage: 'City'
    },
    State: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.State',
        defaultMessage: 'State'
    },
    ZipCode: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Zip Code',
        defaultMessage: 'Zip Code'
    },
    Search: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Search',
        defaultMessage: 'Search'
    },
    SearchingRepairShops: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.Searching repair shops...',
        defaultMessage: 'Searching repair shops...'
    },
    ErrorRetrievingRepairShops: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.searchRepairShops.error',
        defaultMessage: 'Error retrieving repair shops'
    },
    SearchResults: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Search Results',
        defaultMessage: 'Search Results'
    },
    ShopName: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Shop Name',
        defaultMessage: 'Shop Name'
    },
    ApproximateDistance: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Approximate Distance',
        defaultMessage: 'Approximate Distance'
    },
    ShopAddress: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Address',
        defaultMessage: 'Address'
    },
    Phone: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Phone',
        defaultMessage: 'Phone'
    },
    CarwiseRating: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Carwise Rating',
        defaultMessage: 'Carwise Rating'
    },
    RentalBranchLocation: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Rental Branch Location',
        defaultMessage: 'Rental Branch Location'
    },
    Select: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops.Select',
        defaultMessage: 'Select'
    },
    Confirm: {
        id: 'ml.claim.care.shops.schedule.dialog.Confirm',
        defaultMessage: 'Confirm'
    },
    Cancel: {
        id: 'ml.claim.care.shops.schedule.dialog.Cancel',
        defaultMessage: 'Cancel'
    },
    ContactYou: {
        id: 'ml.claim.care.shops.schedule.dialog.This repair shop will contact you shortly discuss next steps',
        defaultMessage: 'This repair shop will contact you shortly discuss next steps'
    },
    RequestingService: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.Requesting Service...',
        defaultMessage: 'Requesting Service...'
    },
    ErrorRequestingService: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.confirm.Error requesting service',
        defaultMessage: 'Error requesting service'
    },
    ServiceRequest: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.confirm.Service request',
        defaultMessage: 'Service request'
    },
    ServiceRequestCreatedSuccessfully: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.confirm.Service Request Created Successfully',
        defaultMessage: 'Service Request Created Successfully'
    },
    RetrievingSchedule: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.Retrieving schedule...',
        defaultMessage: 'Retrieving schedule...'
    },
    ErrorRetrievingSchedules: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.selectRepairShop.Error retrieving schedules',
        defaultMessage: 'Error retrieving schedules'
    },
    ScheduleAppointment: {
        id: 'ml.claim.care.shops.schedule.dialog.Schedule Appointment',
        defaultMessage: 'Schedule Appointment'
    },
    ScheduleAppointmentModalSubtitle: {
        id: 'ml.claim.care.shops.schedule.dialog.Please select an available date and time to schedule your appointment for an estimate',
        defaultMessage: 'Please select an available date and time to schedule your appointment for an estimate'
    },
    BookAppointment: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops-schedules.Book Appointment',
        defaultMessage: 'Book Appointment'
    },
    YourAppointmentBookedSuccessfully: {
        id: 'ml.claim.views.ml-claim-details-self-serve.care-shops-schedules.Your appointment booked successfully',
        defaultMessage: 'Your appointment booked successfully'
    },
    BookAppointmentError: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.bookAppointment.error',
        defaultMessage: 'Unable to book appointment at this time. Your claim consultant will help you schedule the appointment.'
    },
    asdfasdfasdf: {
        id: 'asdfasdfasdfasdf',
        defaultMessage: 'asdfasdfasdfasdf'
    },
});
